/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Offerhover_Communityrating2Inputs */

const id_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringkat Komunitas:`)
};

const ms_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian Komuniti:`)
};

const da_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fællesskabsvurdering:`)
};

const de_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-Bewertung:`)
};

const en_us2_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community Rating:`)
};

const es_es2_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación de la comunidad:`)
};

const es_mx2_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calificación de la comunidad:`)
};

const fil_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating ng Komunidad:`)
};

const fr_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note de la communauté :`)
};

const it_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione community:`)
};

const hu_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közösségi értékelés:`)
};

const nl_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-beoordeling:`)
};

const no_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fellesskapsvurdering:`)
};

const pl_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocena społeczności:`)
};

const pt_br2_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação da comunidade:`)
};

const pt_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação da comunidade:`)
};

const ro_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluare comunitate:`)
};

const fi_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteisön arvio:`)
};

const sv_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community-betyg:`)
};

const vi_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh giá cộng đồng:`)
};

const tr_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topluluk Puanı:`)
};

const cs_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnocení komunity:`)
};

const bg_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка от общността:`)
};

const ru_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг сообщества:`)
};

const uk_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рейтинг спільноти:`)
};

const ar_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقييم المجتمع:`)
};

const hi_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामुदायिक रेटिंग:`)
};

const th_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนนชุมชน:`)
};

const ja_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミュニティ評価：`)
};

const zh_cn2_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社区评分:`)
};

const zh_hant1_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社群評分：`)
};

const ko_home_offerhover_communityrating2 = /** @type {(inputs: Home_Offerhover_Communityrating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커뮤니티 평점:`)
};

/**
* | output |
* | --- |
* | "Community Rating:" |
*
* @param {Home_Offerhover_Communityrating2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_communityrating2 = /** @type {((inputs?: Home_Offerhover_Communityrating2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Communityrating2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_communityrating2(inputs)
	if (locale === "ms") return ms_home_offerhover_communityrating2(inputs)
	if (locale === "da") return da_home_offerhover_communityrating2(inputs)
	if (locale === "de") return de_home_offerhover_communityrating2(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_communityrating2(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_communityrating2(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_communityrating2(inputs)
	if (locale === "fil") return fil_home_offerhover_communityrating2(inputs)
	if (locale === "fr") return fr_home_offerhover_communityrating2(inputs)
	if (locale === "it") return it_home_offerhover_communityrating2(inputs)
	if (locale === "hu") return hu_home_offerhover_communityrating2(inputs)
	if (locale === "nl") return nl_home_offerhover_communityrating2(inputs)
	if (locale === "no") return no_home_offerhover_communityrating2(inputs)
	if (locale === "pl") return pl_home_offerhover_communityrating2(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_communityrating2(inputs)
	if (locale === "pt") return pt_home_offerhover_communityrating2(inputs)
	if (locale === "ro") return ro_home_offerhover_communityrating2(inputs)
	if (locale === "fi") return fi_home_offerhover_communityrating2(inputs)
	if (locale === "sv") return sv_home_offerhover_communityrating2(inputs)
	if (locale === "vi") return vi_home_offerhover_communityrating2(inputs)
	if (locale === "tr") return tr_home_offerhover_communityrating2(inputs)
	if (locale === "cs") return cs_home_offerhover_communityrating2(inputs)
	if (locale === "bg") return bg_home_offerhover_communityrating2(inputs)
	if (locale === "ru") return ru_home_offerhover_communityrating2(inputs)
	if (locale === "uk") return uk_home_offerhover_communityrating2(inputs)
	if (locale === "ar") return ar_home_offerhover_communityrating2(inputs)
	if (locale === "hi") return hi_home_offerhover_communityrating2(inputs)
	if (locale === "th") return th_home_offerhover_communityrating2(inputs)
	if (locale === "ja") return ja_home_offerhover_communityrating2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_communityrating2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_communityrating2(inputs)
	return ko_home_offerhover_communityrating2(inputs)
});
export { home_offerhover_communityrating2 as "home.offerHover.communityRating" }